export default function BookMeetingPage() {
  return (
    <div style={{ width: "100%", height: "100vh" }}>
      <iframe
        src="https://cal.eu/jan-domanski/konsultacja-wstepna"
        width="100%"
        height="100%"
        style={{ border: "none" }}
        title="Umów spotkanie"
      />
    </div>
  );
}
